/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} User_Detail_OrganisedInputs */



/**
* | output |
* | --- |
* | "Events organised ({count})" |
*
* @param {User_Detail_OrganisedInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const user_detail_organised = /** @type {((inputs: User_Detail_OrganisedInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Detail_OrganisedInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Tournois organisés (${i?.count})`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Torneos organizados (${i?.count})`)
	if (locale === "pt") return /** @type {LocalizedString} */ (`Torneios organizados (${i?.count})`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Tornei organizzati (${i?.count})`)
	return /** @type {LocalizedString} */ (`Events organised (${i?.count})`)
});